import { adminRequest } from './adminApi';

export function fetchVisitRewardsConfig() {
  return adminRequest('/loyalty/admin/visit-rewards-config');
}

export function updateVisitRewardsConfig(payload) {
  return adminRequest('/loyalty/admin/visit-rewards-config', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
